(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/ticketgames/ticket-scratch/assets/javascripts/containers/game-container.js') >= 0) return;  svs.modules.push('/components/ticketgames/ticket-scratch/assets/javascripts/containers/game-container.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

const logger = new svs.core.log.Logger('component:ticket-scratch-leia');
const CanvasWrapperLEIA = svs.ticketgames.ticketScratch.components.CanvasWrapperLEIA;
const BubbleWinMessage = svs.tur.bubbleWinMessage.components.BubbleWinMessage;
const Receipt = svs.ticketgames.ticketScratch.components.Receipt;
const normalizeWin = svs.ticketgames.ticketScratch.utils.normalizeWin;
const Payfooter = svs.tur.ReactPayfooter.Payfooter;
const {
  resultDialogNormal,
  resultDialogDemo
} = svs.ticketgames.ticketScratch.utils.resultDialog;
const falcon = svs.ticketgames.falconBridge.falcon;
const {
  confirmClose,
  autoCorrect
} = svs.ticketgames.ticketScratch.utils.customTexts;
const {
  account_services: accountServices,
  dialogs
} = svs.tur.pay;
class GameContainer extends React.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "state", {
      gameResult: undefined,
      shouldShowPlayAgainFooter: false,
      shouldShowAfterScratchUI: false,
      isLoading: true,
      invalidTicket: false,
      betId: undefined
    });
    const {
      ticketInfo,
      onClose
    } = props;
    this.isFullscreen = parseInt(ticketInfo === null || ticketInfo === void 0 ? void 0 : ticketInfo.height, 10) === 0 && parseInt(ticketInfo === null || ticketInfo === void 0 ? void 0 : ticketInfo.width, 10) === 0;
    this.onGameCompleted = this.onGameCompleted.bind(this);
    this.onCloseGame = this.onCloseGame.bind(this);
    this.onBetDone = this.onBetDone.bind(this);
    this.onPrebet = this.onPrebet.bind(this);
    this.onGameLoaded = this.onGameLoaded.bind(this);
    this.validateTicketType = this.validateTicketType.bind(this);
    this.setSoundStatus = this.setSoundStatus.bind(this);
    this.logSoundStatus = this.logSoundStatus.bind(this);
    this.showWinDialog = this.showWinDialog.bind(this);
    this.onAutoCorrect = this.onAutoCorrect.bind(this);
    this.onOpenDoor = this.onOpenDoor.bind(this);
    this.logCorrectionMethod = this.logCorrectionMethod.bind(this);
    this.loadingTimeout = setTimeout(() => {
      svs.tur.apierrors.showErrorMessage({
        onConfirm: onClose
      });
    }, 30000);
    this.events = [{
      eventName: 'HAS_CLAIMED',
      handler: this.onGameCompleted
    }, {
      eventName: 'REPLAY_FINISHED',
      handler: this.onGameCompleted
    }, {
      eventName: 'HAS_BET',
      handler: this.onBetDone
    }, {
      eventName: 'GAME_LOADING',
      handler: this.onGameLoaded
    }, {
      eventName: 'HANDLE_PREBET',
      handler: this.onPrebet
    }, {
      eventName: 'TAG',
      handler: this.validateTicketType
    }, {
      eventName: 'SOUND_STATUS',
      handler: this.setSoundStatus
    }, {
      eventName: 'SHOULD_AUTO_CORRECT',
      handler: this.onAutoCorrect
    }, {
      eventName: 'OPEN_DOOR',
      handler: this.onOpenDoor
    }, {
      eventName: 'CLOSE_GAME',
      handler: this.onCloseGame
    }];
    props.ticketDispatcher.addListeners(this.events, this);
  }
  componentDidMount() {
    this.onComponentWillMount();
    svs.components.loader.hide();
  }
  componentWillUnmount() {
    const {
      ticketDispatcher
    } = this.props;
    ticketDispatcher.removeListeners(this);
    clearTimeout(this.loadingTimeout);
    this.onComponentWillUnmount();
  }
  onComponentWillMount() {}
  onComponentWillUnmount() {
    svs.components.loader.hide();
  }
  setSoundStatus(soundStatus) {
    this.soundStatus = soundStatus;
  }
  logSoundStatus() {
    const {
      ticketInfo,
      gameIsCompleted
    } = this.props;
    const {
      hasSound,
      hasSoundDefaultOn,
      type
    } = ticketInfo;
    if (hasSound && !gameIsCompleted) {
      logger.info('SoundStatus:', this.soundStatus, 'DefaultSoundStatus:', hasSoundDefaultOn, 'GameCode:', type);
    }
  }
  validateTicketType(eventData) {
    if (eventData.event === 'getItgTicket' && eventData.eventType === 'requestResponse' && eventData.requestResponse.data.length >= 1) {
      var _eventData$requestRes;
      const itgTicketType = (_eventData$requestRes = eventData.requestResponse.data[0]) === null || _eventData$requestRes === void 0 ? void 0 : _eventData$requestRes.serviceName;
      const gameName = eventData.gameName;
      if (itgTicketType !== gameName) {
        logger.error("ticketType (".concat(gameName, ") does not match fetched ItgTicket (").concat(itgTicketType, ")"));
        this.setState({
          invalidTicket: true
        });
        svs.tur.apierrors.showErrorMessage({
          onConfirm: this.props.onClose
        });
      }
    }
  }
  onPrebet(data) {
    this.setState({
      gameResult: undefined,
      shouldShowAfterScratchUI: false
    });
    const {
      ticketInfo,
      voucherCode,
      wagerId,
      isPurchaseDisabled,
      onClose,
      demo: isDemo
    } = this.props;
    const {
      resolve,
      reject,
      stake,
      demo
    } = data;
    const {
      currencyFormatter
    } = svs.ticketgames.gameHandler.constants.leia;
    if (demo || isDemo || voucherCode) {
      var _svs$ticketgames$falc;
      (_svs$ticketgames$falc = svs.ticketgames.falconBridge.falcon.instance) === null || _svs$ticketgames$falc === void 0 || (_svs$ticketgames$falc = _svs$ticketgames$falc.bridgeFrame) === null || _svs$ticketgames$falc === void 0 || _svs$ticketgames$falc.focus();
      return resolve();
    } else if (isPurchaseDisabled) {
      reject();
      return onClose();
    }
    if (wagerId && wagerId.toLowerCase() !== 'pending') {
      logger.warn("wager with wagerId ".concat(wagerId, " was not found for game ").concat(ticketInfo === null || ticketInfo === void 0 ? void 0 : ticketInfo.type));
      svs.ui.dialog.api.add(new svs.ui.dialog.Confirm({
        branding: svs.ui.dialog.branding.TUR,
        type: svs.ui.dialog.type.ERROR,
        icon: 'exclamation-sign',
        title: 'Fel',
        message: [{
          type: svs.ui.dialog.message.TEXT,
          text: 'Spelet kunde inte hittas.'
        }],
        actions: [{
          title: 'OK',
          callback: (e, forms, dialog) => {
            dialog.close();
            onClose();
          }
        }]
      }));
      reject();
      return;
    }
    const totalCost = svs.utils.format.CurrencyFromJupiterString(currencyFormatter(stake.value));
    const confirmPaymentOptions = {
      title: "Vill du betala en ".concat(ticketInfo.name, " f\xF6r ").concat(totalCost, " kr?"),
      messages: ['Observera att spelet inte går att annullera.']
    };
    const product = 'SKRYS';
    let accountBalance;
    const calls = [{
      in: () => ({
        price: totalCost,
        product
      }),
      fn: accountServices.playerSession
    }, {
      in: () => ({
        spelpausFlags: [accountServices.playerSpelpaus.CONSTANTS.QUICK_GAMES]
      }),
      fn: accountServices.playerSpelpaus
    }, {
      fn: accountServices.playerSuspension
    }, {
      fn: accountServices.dayTimeLimit
    }, {
      in: () => ({
        price: totalCost
      }),
      fn: accountServices.accountBalance,
      out: args => ({
        accountBalance
      } = args)
    }, {
      in: () => _objectSpread({
        price: totalCost,
        accountBalance
      }, confirmPaymentOptions),
      fn: dialogs.confirmPayment
    }, {
      fn: _ref => {
        let {
          next
        } = _ref;
        resolve();
        next();
      }
    }];
    const cancel = () => {
      reject();
      onClose();
    };
    svs.tur.pay.initPay({
      calls,
      cancel
    });
  }
  onBetDone(bet) {
    const {
      ticketInfo,
      ticketDispatcher,
      excludeIdFromUrl = false,
      demo
    } = this.props;
    const {
      data,
      betAmount,
      serviceName,
      receiptId
    } = bet;
    const ticketPrice = betAmount.value / 100;
    if (!demo) {
      var _svs$ticketgames$tick;
      this.setState({
        betId: data.id
      });
      (_svs$ticketgames$tick = svs.ticketgames.ticketScratch.utils.tracking.gameSpecificTracking[ticketInfo.type]) === null || _svs$ticketgames$tick === void 0 || _svs$ticketgames$tick.bet();
      ticketDispatcher.sendAnalytics(data.id, serviceName, ticketPrice, ticketInfo, false);
      svs.components.account_balance && svs.components.account_balance.get(true);
      if (!excludeIdFromUrl) {
        history.replaceState(null, '', receiptId + window.location.search);
      }
    }
  }
  onGameLoaded() {
    clearTimeout(this.loadingTimeout);
    this.setState({
      isLoading: false
    });
  }
  onCloseGame() {
    let {
      type
    } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    const {
      demo,
      onClose,
      ticketInfo
    } = this.props;
    if (type === 'CONFIRM') {
      const {
        title,
        message,
        cancelTitle,
        actionTitle
      } = confirmClose(ticketInfo.type, demo);
      const dialog = new svs.components.dialog.Confirm({
        branding: svs.components.dialog.branding.TUR,
        icon: 'help-2',
        title,
        message,
        actions: [{
          title: cancelTitle,
          callback: () => {
            dialog.close();
          }
        }, {
          title: actionTitle,
          callback: () => {
            onClose();
            dialog.close();
          }
        }]
      });
      svs.components.dialog.api.add(dialog);
    } else {
      onClose();
    }
  }
  animateReceipt() {
    const receipt = document.querySelector('#ticket-receipt');
    if (receipt) {
      gsap.to(receipt, {
        opacity: 1,
        duration: 2
      });
    }
  }
  onAutoCorrect() {
    const {
      type
    } = this.props.ticketInfo;
    const {
      title,
      message,
      cancelTitle,
      actionTitle
    } = autoCorrect(type);
    const dialog = new svs.components.dialog.Confirm({
      branding: svs.components.dialog.branding.TUR,
      icon: 'help-2',
      title,
      message,
      actions: [{
        title: cancelTitle,
        callback: () => {
          falcon.instance.notifierProxy.sendNotification('autoCorrect', false);
          dialog.close();
        }
      }, {
        title: actionTitle,
        callback: () => {
          falcon.instance.notifierProxy.sendNotification('autoCorrect', true);
          dialog.close();
        }
      }]
    });
    svs.components.dialog.api.add(dialog);
  }
  onOpenDoor(data) {
    const {
      demo,
      ticketInfo
    } = this.props;
    if (!demo) {
      var _svs$ticketgames$tick2;
      (_svs$ticketgames$tick2 = svs.ticketgames.ticketScratch.utils.tracking.gameSpecificTracking[ticketInfo.type]) === null || _svs$ticketgames$tick2 === void 0 || _svs$ticketgames$tick2.openDoor(data);
    }
  }
  showWinDialog(result) {
    const {
      demo,
      onClose,
      nextVoucher = null,
      hasUnscratchedTicket = false,
      ticketInfo: {
        type
      }
    } = this.props;
    if (demo) {
      resultDialogDemo(result.wonAmount, onClose, this.onPlayAgain);
    } else {
      resultDialogNormal(result.wonAmount, onClose, this.onPlayAgain, nextVoucher, hasUnscratchedTicket, type);
    }
  }
  logCorrectionMethod(result) {
    var _result$data;
    const {
      type
    } = this.props.ticketInfo;
    if (result !== null && result !== void 0 && (_result$data = result.data) !== null && _result$data !== void 0 && (_result$data = _result$data.revelationData) !== null && _result$data !== void 0 && _result$data.hasOwnProperty('autoCorrected')) {
      const autoCorrected = result.data.revelationData.autoCorrected;
      logger.info("CorrectionMethod (".concat(type, "): ").concat(autoCorrected ? 'AUTO' : 'MANUAL'));
    }
  }
  onGameCompleted(result) {
    const {
      demo,
      shouldShowConfetti = true,
      ticketInfo,
      shouldShowPlayAgain = false,
      gameIsCompleted
    } = this.props;
    this.logSoundStatus();
    if (!demo && !gameIsCompleted) {
      var _svs$ticketgames$tick3;
      (_svs$ticketgames$tick3 = svs.ticketgames.ticketScratch.utils.tracking.gameSpecificTracking[ticketInfo.type]) === null || _svs$ticketgames$tick3 === void 0 || _svs$ticketgames$tick3.corrected();
      this.logCorrectionMethod(result);
      svs.components.analytics.trackEvent({
        category: 'Wager',
        action: 'ticket_completed',
        opt_label: ticketInfo.name
      });
    }
    const normalizedResult = normalizeWin(result);
    this.setState({
      gameResult: normalizedResult
    });
    if (shouldShowPlayAgain && (!this.isFullscreen || gameIsCompleted)) {
      this.setState({
        shouldShowPlayAgainFooter: true
      });
    }
    setTimeout(() => {
      this.setState({
        shouldShowAfterScratchUI: true
      });
    }, 500);
    setTimeout(() => {
      this.animateReceipt();
    }, 2000);
    if (normalizedResult.winFlag && !demo) {
      setTimeout(() => {
        shouldShowConfetti && svs.tur.confettiCannon();
      }, 1000);
    }
    if (this.isFullscreen && !gameIsCompleted) {
      this.showWinDialog(result);
    }
    svs.components.account_balance && svs.components.account_balance.get(true);
  }
  render() {
    const {
      voucherCode,
      demo,
      wagerId,
      ticketDispatcher,
      ticketNumber,
      skinId,
      ticketInfo,
      isPending,
      onClose,
      onPlayAgain,
      gameIsCompleted,
      fetchedGame,
      onFullscreenChange
    } = this.props;
    const {
      gameResult,
      shouldShowPlayAgainFooter,
      shouldShowAfterScratchUI,
      isLoading,
      invalidTicket,
      betId
    } = this.state;
    const {
      disableGrassroot
    } = this;
    const shouldShowReceipt = gameIsCompleted && !isLoading;
    const options = _objectSpread(_objectSpread({
      demo,
      product: ticketInfo.type
    }, gameResult), {}, {
      disableGrassroot
    });
    return React.createElement(React.Fragment, null, React.createElement("div", {
      className: "game-container ".concat(gameResult && 'game-complete', " ").concat(ticketInfo.type, " ").concat(isLoading && 'isLoading', " ").concat(!this.isFullscreen && 'margin-top-2')
    }, shouldShowAfterScratchUI && !this.isFullscreen && React.createElement("div", {
      className: "qa-win-message-container game-header"
    }, React.createElement(BubbleWinMessage, {
      options: options
    })), ticketInfo && React.createElement("div", {
      className: "game-canvas ".concat(!this.isFullscreen && 'ticket-shadow', " ").concat(!shouldShowReceipt && !this.isFullscreen && 'margin-bottom-2')
    }, !invalidTicket && React.createElement(CanvasWrapperLEIA, {
      betId: betId,
      demo: demo,
      gameResult: gameResult,
      isFullscreen: this.isFullscreen,
      isLoading: isLoading,
      isPending: isPending,
      onClose: onClose,
      onFullscreenChange: onFullscreenChange,
      skinId: skinId,
      ticketDispatcher: ticketDispatcher,
      ticketInfo: ticketInfo,
      ticketNumber: ticketNumber,
      voucherCode: voucherCode,
      wagerId: wagerId
    }))), shouldShowReceipt ? React.createElement(Receipt, {
      fetchedGame: fetchedGame,
      style: {
        opacity: 0
      },
      ticketInfo: ticketInfo
    }) : null, shouldShowPlayAgainFooter && React.createElement(Payfooter, {
      buttons: [{
        primary: true,
        text: 'Spela igen',
        onClick: onPlayAgain
      }],
      isFixed: true
    }), gameResult && (!this.isFullscreen || gameIsCompleted) && this.getFooter());
  }
}
setGlobal('svs.ticketgames.ticketScratch.containers.GameContainer', GameContainer);

 })(window);